import React, { InputHTMLAttributes } from "react";
import "./styles.scss";
import classNames from "classnames";
import PrivateMark from "../PrivateMark";

interface SmartInputProps extends InputHTMLAttributes<HTMLInputElement> {
    register: any;
    name: string;
    error?: { message: string };
    showPrivateMark?: boolean;
}

const SmartInput = (props: SmartInputProps): JSX.Element => {
    const { register, name, className, showPrivateMark, ...restOfProps } =
        props;
    return (
        <div className="relative">
            <input
                className={classNames({
                    [className]: true,
                    "smart-input": true
                })}
                ref={register}
                name={name}
                {...restOfProps}
            />
            {showPrivateMark && <PrivateMark />}
            {props.error && (
                <div className="input-error">{props.error.message}</div>
            )}
        </div>
    );
};

export default SmartInput;
